import React from "react";
import "./SalesQuantityMulti.scss";
import { Box, TextField, List, ListItem, ListItemText } from "@mui/material";
import HelpText, { getHelpText } from "../HelpText/HelpText";

const SalesQuantityMulti = (props) => {
  console.group("SalesQuantityMulti");
  console.log(props);
  console.groupEnd();
  return (
    <div
      className="SalesQuantityMulti"
      data-testid="SalesQuantityMulti"
      style={{ width: "100%" }}
    >
      <h2 className="sectionTitle center">Sales Quantity</h2>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        m={1}
        p={1}
      >
        <List>
          {props.sales.map(function (d, idx) {
            return (
              <ListItem key={idx}>
                <ListItemText>
                  {`Species Code: ${d.species}`}
                  <br />
                  {`Species Name: ${d.species_label}`}
                  <br />
                  {`Qty. Available: ${d.available}`}
                  <br />
                  <Box display="grid" alignItems="center">
                    <Box>
                      <TextField
                        label="Sold:"
                        className="number-of-input"
                        variant="standard"
                        inputProps={{
                          min: 0,
                          max: d.original_available - d.original_sold,
                          style: { textAlign: "center" },
                        }}
                        value={d.sold === 0 ? "" : d.sold}
                        name={"sold_" + idx}
                        type="number"
                        onChange={(e) => props.handleSoldChange(e, idx)}
                        helperText={getHelpText(
                          props.helpText,
                          "sales_quantity"
                        )}
                      />
                    </Box>
                    <Box>
                      <HelpText
                        helpText={getHelpText(props.helpText, "sales_quantity")}
                      />
                    </Box>
                  </Box>
                </ListItemText>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </div>
  );
};

export default SalesQuantityMulti;
